export const calculateExpiresTask = (task) => {
  const taskDurationMillis = task?.TaskDuration;
  if (!isNaN(taskDurationMillis)) {
    const now = new Date();
    const endDate = new Date(now.getTime() + taskDurationMillis);
    return Date.parse(endDate.toISOString());
  }
  return 0;
};

export function parseTask(json) {
  let answer = {};
  try {
    answer = JSON.parse(json?.ReviewJson);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }

  const expiresAt = calculateExpiresTask(json);

  return {
    taskId: json.IdTask,
    formId: json.IdForm,
    projectId: json.IdProject,
    projectTitle: json.ProjectTitle,
    columns: (json?.Columns || []).map((column) => ({
      name: column.Name,
      data: column.Data,
      type: column.Type,
    })),
    answers: Object.keys(json?.Answers || {}).reduce(
      (answers, keyAnswer) => ({
        ...answers,
        [keyAnswer]: JSON.parse(json?.Answers[keyAnswer]),
      }),
      {},
    ),
    supplierId: json.IdSupplier,
    answer,
    isReview: json.isReview,
    expiresAt,
  };
}

export function formatMarkTask(json) {
  return {
    IdTask: json.taskId,
    Mark: json.mark,
  };
}
